var map = {
	"./rank1.png": "a220",
	"./rank2.png": "4894",
	"./rank3.png": "24f2",
	"./rank_1.png": "68f0",
	"./rank_2.png": "d860",
	"./rank_3.png": "001f",
	"./rank_down.png": "0660",
	"./rank_up.png": "4341"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1900";